import React, { useState } from "react"
import PropTypes from "prop-types"
import { CustomArrows } from "./carousel-transformer-styled"
import MultiCarousel from "react-multi-carousel"
import {
  carouselTransformer,
  carouselArrowRight,
  carouselArrowLeft,
  carouselImage,
  modalImage,
  modalButton,
} from "./carousel-transformer.module.scss"

const CarouselTransformer = ({ html }) => {
  const [selectedImage, setSelectedImage] = useState(false)
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    mobile_tab: {
      breakpoint: { max: 900, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  }
  return (
    <>
      <MultiCarousel
        className={carouselTransformer}
        transitionDuration={500}
        customRightArrow={<CustomArrowsComponent direction="right" />}
        customLeftArrow={<CustomArrowsComponent direction="left" />}
        responsive={responsive}
        infinite={true}
        arrows={true}
      >
        {html.map((element, key) => {
          return (
            <div
              tabIndex={0}
              role="button"
              key={key}
              className={carouselImage}
              onClick={() => setSelectedImage(element)}
              onKeyDown={() => setSelectedImage(element)}
            >
              {element}
            </div>
          )
        })}
      </MultiCarousel>
      {selectedImage && (
        <div
          tabIndex={0}
          role="button"
          onKeyDown={() => setSelectedImage(false)}
          onClick={() => setSelectedImage(false)}
          className={modalImage}
          small={selectedImage.props.src}
          large={selectedImage.props.src}
          alt={selectedImage.props.alt}
        >
          <button
            onClick={() => setSelectedImage(false)}
            className={modalButton}
          >
            &times;
          </button>
          <img src={selectedImage.props.src} alt={selectedImage.props.alt} />
        </div>
      )}
    </>
  )
}

const CustomArrowsComponent = ({ onClick, direction }) => {
  return (
    <CustomArrows
      className={direction === "left" ? carouselArrowLeft : carouselArrowRight}
      onClick={() => onClick()}
    />
  )
}

CarouselTransformer.propTypes = {
  html: PropTypes.array,
}
CustomArrowsComponent.propTypes = {
  onClick: PropTypes.func,
  direction: PropTypes.string,
}

export default CarouselTransformer
